export default "__VITE_ASSET__0bac91cc__"